import { LabelHTMLAttributes, forwardRef, useEffect, useMemo, useState } from "react"
import { LiaCheckSolid } from "react-icons/lia";
import { debounce, isEqual } from "lodash-es"

type Label = string | { label: string, value: string }

export interface MultiselectProps extends LabelHTMLAttributes<HTMLLabelElement> {
    optionLabels: Label[]
    onChange?: (labels: Label[]) => void
    value?: Label[]
    timeout?: number
}

export const Multiselect = forwardRef(({ optionLabels, value = [], onChange, children, className, timeout = 1000, ...rest }: MultiselectProps, ref) => {
    const [labels, setLabels] = useState<Label[]>(value)

    const addLabel = (label: Label) => setLabels(labels.concat(label))
    const rmLabel = (label: Label) => setLabels(labels.filter(l => l != label))


    const f = useMemo(() => debounce((value) => {
        onChange?.(value)
    }, timeout), [onChange])

    useEffect(() => {
        f.cancel()
        f(labels)
    }, [labels])

    useEffect(() => {
        if (!isEqual(value, labels))
            setLabels(value)
    }, [value])

    return <label className={`dropdown dropdown-bottom ${className ?? ''}`} {...rest}>
        <div tabIndex={0}>
            {children}
        </div>
        <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow">
            {optionLabels.map(label => <li key={label.toString()}>
                <a
                    className={`rounded-none ${labels.includes(label) ? 'bg-primary' : ''}`}
                    onClick={() => labels.includes(label) ? rmLabel(label) : addLabel(label)}>
                    {typeof label == 'string' ? label : label.label}
                    {labels.includes(label) && <LiaCheckSolid className="ml-auto" />}
                </a>
            </li>)}
        </ul>
    </label>
})